const MAX_IMPORT_ROWS = 500;

export function parseImportSheet(sheet) {
  if (!Array.isArray(sheet) || !sheet.length) throw new Error('表格为空，请先下载模板填写');
  const [first, second] = sheet[0].map((value) => String(value ?? '').trim());
  if (first !== '视频链接' || !['商品名称（可选）', '商品名称'].includes(second)) {
    throw new Error('表头不匹配，请使用下载的模板填写');
  }

  const rows = [];
  for (const [index, cells] of sheet.entries()) {
    if (index === 0 || cells.every((value) => value == null || String(value).trim() === '')) continue;
    if (cells.slice(2).some((value) => value != null && String(value).trim() !== '')) {
      throw new Error(`第 ${index + 1} 行有多余列，请只填写视频链接和商品名称`);
    }
    const url = cells[0];
    const productName = cells[1];
    if (typeof url !== 'string' || !url.trim()) throw new Error(`第 ${index + 1} 行缺少视频链接`);
    if (productName != null && typeof productName !== 'string') throw new Error(`第 ${index + 1} 行商品名称应为文字`);
    rows.push({ url: url.trim(), productName: productName?.trim() ?? '', rowNumber: index + 1 });
    if (rows.length > MAX_IMPORT_ROWS) throw new Error(`每次最多导入 ${MAX_IMPORT_ROWS} 条视频`);
  }
  if (!rows.length) throw new Error('表格没有待导入的视频链接');
  return rows;
}
